export enum UserAction {
  Login = "login",
  Logout = "logout",
}
